import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import ContentCardFooter from '../common/template/contentCardFooter';
import Background from '../common/template/background';
import DateFormat from '../common/dateFormat/DateFormat';
import sologo from '../assets/images/sologo.png';
import logoTrilha from '../assets/images/logo_trilha.png';
import Form from './incubacaoAvaliacaoForm';
import IncubacaoAvaliacao from './incubacaoAvaliacao';
import imagemFundo from '../assets/images/trilhaConhecimento/fundo.png';
import imagemFundoIdeacao from '../assets/images/trilhaConhecimento/ideacao/fundo.png';
import { setModoTela, initForm, salvar, getLista, getListaUsuario } from './incubacaoAvaliacaoActions';
import { getLista as getListaTexto } from '../texto/textoActions';
import TextoInput from '../texto/textoInput';

class AdmAvaliacao extends Component {

	state = {
		linhaSelecionada: null,
		incubacaoAvaliacaoCarregada: null
	}

	componentDidMount() {
		this.props.getLista();
		this.props.getListaUsuario();
		// this.props.getListaIdeacao();
		// this.props.getListaPrototipo();
		// this.props.getListaValidacao();
		// this.props.getListaPitch();
		this.props.getListaTexto();
	}

    componentWillMount() {
    }

    render() {
		
		let fundo = imagemFundo;
		if (this.props.modoTela == 'ideacao') {
			fundo = imagemFundoIdeacao;
		}

        return (
			<>
				{this.state.incubacaoAvaliacaoCarregada ? (
					<IncubacaoAvaliacao 
						eventoAdm={() => this.setState({
							incubacaoAvaliacaoCarregada: null
						})} 
						incubacaoAvaliacaoCarregada={this.state.incubacaoAvaliacaoCarregada} />
				) : (
					<Background
						backgroundPosition={'center'}
						gradientStart='#ffffff'
						gradientEnd='#ffffff'>
						<Content>
							<Aguardando aguardando={this.props.aguardando} />

							{this.props.modoTela == 'trilha' ? this.trilha() : null}
							
							{this.props.modoTela == 'cadastro' ? <Form onSubmit={this.props.salvar} /> : null}
						</Content>
					</Background>
				)}
			</>
        )
    }

	trilha() {

		let lista = this.props.lista.filter(item => {
			if (this.state.pesquisar
				&& !(`${item.nome} ${DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)} 
					${item.nome_usuario} ${item.nome_empresa}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		return (
			<ContentCard>
				<ContentCardHeader>
					
					<h3 style={{ color: '#0F2748', textAlign: 'center', fontWeight: 'bold', marginBottom: 16 }}>TRILHA DE INCUBAÇÃO</h3>

					<Row alignCenter>
						<Grid cols='12 8 6 3' style={{ margin: 8 }}>
							<Button
								text='Criar Nova Banca'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}} />
						</Grid>
					</Row>
				
				</ContentCardHeader>
				<ContentCardBody>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value, paginacaoIndice: 0 });
						}} />
			
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Data</Th>
								<Th alignCenter>Empreendedor</Th>
								<Th alignCenter>Nome do Projeto</Th>								
								<Th alignCenter>1º Ano</Th>
								<Th alignCenter>2º Ano</Th>
								<Th alignCenter>3º Ano</Th>
								<Th alignCenter>Graduação</Th>
								<Th alignCenter></Th>
								<Th alignCenter></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => {
								
								return (
									<Tr key={item.id}>
										<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)}</Td>
										<Td alignCenter>{item.nome_usuario}</Td>
										<Td alignCenter>{item.nome_empresa}</Td>
										<Td alignCenter minWidth={10}>{DateFormat.formatarDataSqlParaTela(item.data_ano1)}</Td>
										<Td alignCenter minWidth={10}>{DateFormat.formatarDataSqlParaTela(item.data_ano2)}</Td>
										<Td alignCenter minWidth={10}>{DateFormat.formatarDataSqlParaTela(item.data_ano3)}</Td>
										<Td alignCenter minWidth={10}>{DateFormat.formatarDataSqlParaTela(item.data_graduacao)}</Td>
										<Td alignCenter>
											<Button
												text={'Acompanhar'}
												type={'secondary'}
												icon={'fa fa-plus'}
												event={() => {
													this.setState({
														...this.state,
														incubacaoAvaliacaoCarregada: {
															...item
														}
													});
												}} />
										</Td>
										<Td alignCenter>
											<Button
												text={'Editar'}
												type={'secondary'}
												icon={'fa fa-plus'}
												event={() => {
													this.props.setModoTela('cadastro', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />
										</Td>
									</Tr>
								);
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.incubacaoAvaliacao.modoTela,
	aguardando: state.incubacaoAvaliacao.aguardando,
	lista: state.incubacaoAvaliacao.lista,
	listaIdeacao: [],
	listaPrototipo: [],
	listaValidacao: [],
	listaPitch: [],
	incubacaoAvaliacaoTitulo: state.texto.lista.filter(item => item.chave == 'incubacaoAvaliacaoTitulo').map(item => item.valor)[0],
	incubacaoAvaliacaoTituloNaoIniciada: state.texto.lista.filter(item => item.chave == 'incubacaoAvaliacaoTituloNaoIniciada').map(item => item.valor)[0],
	incubacaoAvaliacaoDescricaoNaoIniciada: state.texto.lista.filter(item => item.chave == 'incubacaoAvaliacaoDescricaoNaoIniciada').map(item => item.valor)[0]
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, getLista, getListaUsuario,
	getListaTexto
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AdmAvaliacao);
